export default __webpack_public_path__ + "static/media/riot_icon.85101daf.png";